<template>
  <div>
    <nav class="navbar navbar-expand-lg navbar-light bg-light py-3">
      <div class="container-fluid">
        <router-link id="title" class="navbar-brand fw-bold" to="/console"
          >Laguna Black Belt Prep Admin</router-link
        >
        <button
          class="navbar-toggler"
          type="button"
          data-bs-toggle="offcanvas"
          data-bs-target="#offcanvas"
          aria-controls="offcanvas"
        >
          <span class="navbar-toggler-icon"></span>
        </button>
        <div
          class="d-flex flex-grow-1 align-items-center d-none d-lg-block"
          style="flex-basis: auto"
        >
          <ul class="navbar-nav me-auto">
            <li class="nav-item">
              <router-link
                :class="
                  'nav-link' + ($route.fullPath == '/console' ? ' active' : '')
                "
                aria-current="page"
                to="/console"
                >Console</router-link
              >
            </li>
            <li class="nav-item">
              <router-link
                :class="
                  'nav-link' + ($route.fullPath == '/videos' ? ' active' : '')
                "
                aria-current="page"
                to="/videos"
                >Videos</router-link
              >
            </li>

            <li class="nav-item">
              <router-link
                :class="
                  'nav-link' + ($route.fullPath == '/profile' ? ' active' : '')
                "
                aria-current="page"
                to="/profile"
                >My Profile</router-link
              >
            </li>

            <li class="nav-item">
              <router-link
                :class="
                  'nav-link' + ($route.fullPath == '/email-link' ? ' active' : '')
                "
                aria-current="page"
                to="/email-link"
                >Email Link</router-link
              >
            </li>

            <li class="nav-item">
              <router-link
                :class="
                  'nav-link' + ($route.fullPath == '/bunkai' ? ' active' : '')
                "
                aria-current="page"
                to="/bunkai"
                >Bunkai</router-link
              >
            </li>
          </ul>
        </div>
      </div>
    </nav>

    <div class="offcanvas offcanvas-end" tabindex="-1" id="offcanvas">
      <div class="offcanvas-header">
        <h5
          class="offcanvas-title"
          v-text="offcanvasTitle ? offcanvasTitle : 'Kovar\'s Laguna'"
        ></h5>
        <button
          type="button"
          class="btn-close text-reset"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
        ></button>
      </div>
      <div class="offcanvas-body px-5">
        <router-link
          :class="'d-block mt-2 text-decoration-none ' + ($route.fullPath == '/console' ? ' text-primary' : 'text-dark')"
          to="/console"
          >Console</router-link
        >
        <router-link
          :class="'d-block mt-2 text-decoration-none ' + ($route.fullPath == '/videos' ? ' text-primary' : 'text-dark')"
          to="/videos"
          >Videos</router-link
        >
        <router-link
          :class="'d-block mt-2 text-decoration-none ' + ($route.fullPath == '/profile' ? ' text-primary' : 'text-dark')"
          to="/profile"
          >My Profile</router-link
        >
        <router-link
          :class="'d-block mt-2 text-decoration-none ' + ($route.fullPath == '/email-link' ? ' text-primary' : 'text-dark')"
          to="/email-link"
          >Email Link</router-link
        >
        <router-link
          :class="'d-block mt-2 text-decoration-none ' + ($route.fullPath == '/bunkai' ? ' text-primary' : 'text-dark')"
          to="/bunkai"
          >Bunkai</router-link
        >
      </div>
    </div>
  </div>
</template>

<script>
import { Offcanvas } from "bootstrap";

export default {
  props: {
    offcanvasTitle: String,
  },
  watch: {
    $route() {
      console.log("Collapse offcanvas (route change)"); //TODO - collapse only if collapse is open? :)
      var offcanvas = new Offcanvas(document.getElementById("offcanvas"));
      console.log(offcanvas);
      offcanvas.hide();
    },
  },
};
</script>

<style scoped>
#title {
  background: linear-gradient(92.73deg, #d62a26 16.73%, #8b2220 90.6%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
</style>